import ErrorOutlineSharpIcon from '@mui/icons-material/ErrorOutlineSharp';
import { Box, Typography } from '@mui/material';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { useBizLogicActions, useSystemActions } from 'stores';
import { MotionWrapper } from 'utils';

const Error = () => {
	const { getImage } = useSystemActions();
	const { t } = useTranslation();
	const navigate = useNavigate();
	const { state } = useLocation();
	const error = state?.error;
	const { resetProduct, resetVerify } = useBizLogicActions();

	useEffect(() => {
		if (!error || error.code === 0) navigate('/', { replace: true });
		return () => {
			resetProduct();
			resetVerify();
		};
	}, []);

	if (!error || error.code === 0) return <></>;

	return (
		<>
			<MotionWrapper spacing={1} alignItems="center" p={1}>
				<Box
					component="img"
					sx={{
						width: '95%',
						maxHeight: '30vw',
						objectFit: 'contain',
						marginBottom: '25%',
					}}
					alt="AR_Logo"
					// src={getImage('logo_ar.png')}
					src={getImage(process.env.REACT_APP_CUSTOM_LOGO || '')}
				/>
				<Box>
					<Typography>
						<ErrorOutlineSharpIcon
							sx={{
								height: '200px',
								width: '200px',
								color: 'primary.main',
							}}
						/>
					</Typography>
				</Box>
				<Box
					sx={{
						paddingTop: '20%',
					}}
				>
					<Typography
						variant="body1"
						color="primary.main"
						align="center"
						style={{ whiteSpace: 'pre-wrap' }}
					>
						{error.message
							? t(error.message)
							: t('app.error.unknown')}
					</Typography>
				</Box>
			</MotionWrapper>
		</>
	);
};

export default Error;
